import { IFeatureFlags } from 'types';
import { beta } from './beta';

// inherits beta configuration
export const develop: IFeatureFlags = Object.assign({}, beta, {
});

Object.freeze(develop);
